import { useListsApi } from '@shared/model'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware( () => {
  void useListsApi()
})
